import { render } from "./NoNotificationsIcon.vue?vue&type=template&id=407b2ac4"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/icons/NoNotificationsIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "407b2ac4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('407b2ac4', __exports__)) {
    api.reload('407b2ac4', __exports__)
  }
  
  module.hot.accept("./NoNotificationsIcon.vue?vue&type=template&id=407b2ac4", () => {
    api.rerender('407b2ac4', render)
  })

}


export default __exports__